export const COMPANY_SHARE = 0.30;
export const WORKER_SHARE = 0.70;

export function calculateOrderMoney(order) {
  const customerPaid = Number(order?.totalAmount || 0);
  const workerPayout = Number(
    order?.workerPayout ?? order?.workerEarnings ?? (customerPaid * WORKER_SHARE)
  );
  const companyShare = Number(order?.companyShare ?? (customerPaid - workerPayout));
  return { customerPaid, workerPayout, companyShare };
}

export function isPaidOrder(order) {
  const paymentStatus = (order?.paymentStatus || '').toLowerCase();
  return paymentStatus === 'paid';
}

export function summarizeFinance(orders) {
  return (orders || []).reduce((acc, order) => {
    acc.orders += 1;
    if (isPaidOrder(order)) {
      const money = calculateOrderMoney(order);
      acc.customerPaid += money.customerPaid;
      acc.workerPayable += money.workerPayout;
      acc.companyRevenue += money.companyShare;
    }
    return acc;
  }, { orders: 0, customerPaid: 0, workerPayable: 0, companyRevenue: 0 });
}
